module.exports = __webpack_public_path__ + "static/scale-model-of-aurora-regional-fire-museum-in-aurora-illinois-ae59a1e59be3e2e9ef294a267acc13c5.png";